import { AbstractController, AbstractControllerParams } from "../../abstract/AbstractController";
import { ProtonService, ProtonServiceEvent } from "../../services/Proton";


export class WalletController extends AbstractController {

    private actionButton:HTMLElement | null;
    public protonService:ProtonService;
    constructor(params:AbstractControllerParams){

        super(params);
        this.protonService = new ProtonService();
        this.rootNode = params.rootNode;
        this.mountUI();
        this.bindEvents()
        
    }

    mountUI(): void {
        
        if (!this.rootNode) throw new Error('No root node')
        this.actionButton = this.rootNode.querySelector('#login-button');

    }

    bindEvents(): void {
       this.actionButton?.addEventListener('click',(e)=>{

            e.preventDefault()
            console.log("Let's connect")
            this.protonService.login();

        })

        window.addEventListener(ProtonServiceEvent.PROTON_LOGIN_SUCCESS,()=>{

            console.log(`Ok connected as ${window['proton'].session.auth.actor}`)
            

        })
    }

}